import React from 'react';

// Components
import { Button, Text, Space, Conditional } from '@cashfree-intl/coherent';
import CustomIcons from 'components/CustomIcons';

// Types
import { ICON_NAME } from 'components/CustomIcons/types';
import { AlternateIdProofProps } from './types';

// Styled
import { StyledNameMatchDocSection } from './styled';

// Constants
import { defaultAlternateDocHeader, defaultButtonText } from './constants';

const AlternateIdProof = ({
  hasNotSubmittedAlternateDoc,
  onClick,
  docName,
  isAlternateDocRejected,
  isStepInProgress = true,
  buttonText = defaultButtonText,
  alternateDocHeader = defaultAlternateDocHeader,
}: AlternateIdProofProps) => (
  <>
    <Conditional if={hasNotSubmittedAlternateDoc}>
      <Button
        disabled={!isStepInProgress}
        primary={isStepInProgress}
        secondary={!isStepInProgress}
        type="button"
        size="small"
        onClick={onClick}
        className="mt-2"
        data-testid="submit-alternate-id-proof-button"
      >
        {buttonText}
      </Button>
    </Conditional>
    <Conditional if={!hasNotSubmittedAlternateDoc}>
      <StyledNameMatchDocSection data-testid="name-match-doc-section">
        <Text variant="b14" color="bodyLight" className="alternate-doc-header">
          {alternateDocHeader}
        </Text>
        <Space alignItems="center">
          <CustomIcons componentName={ICON_NAME.GENERIC_FILE} />
          <Text className="ml-1">{docName}</Text>
          <Button link onClick={onClick} className="pl-0">
            View
          </Button>
        </Space>
        <Conditional if={isAlternateDocRejected}>
          <Text variant="b12" color="danger">
            The document you have submitted has been rejected.
          </Text>
        </Conditional>
      </StyledNameMatchDocSection>
    </Conditional>
  </>
);

export default AlternateIdProof;
